module.exports = __webpack_public_path__ + "img/photo-placeholder.fc047347.png";